import React from "react";
import {Grid} from "@material-ui/core";
import Form from "../../../lib/appfuse-react/component/Form";
import TextField from "../../../lib/appfuse-react/component/TextField";
import SelectField from "../../../lib/appfuse-react/component/SelectField";

function ContactPerson(props) {
    const {value={}, change={}, readOnly, required, enrollment = false} = props;

    const variant = readOnly? 'standard':'outlined';

    return (
        <Form value={value} change={change} onChange={props.onChange} readOnly={readOnly}>
            <Grid container spacing={2} item xs={12}>
                {/*姓名*/}
                <Grid item xs={3}>
                    <TextField name='contactPerson' label='Name' variant={variant} fullWidth required={required}/>
                </Grid>
                {/*電子郵件*/}
                <Grid item xs={3}>
                    <TextField name='contactEmail' label='Email' variant={variant} fullWidth required={required}/>
                </Grid>
                {/*手機*/}
                <Grid item xs={3}>
                    <TextField name='contactMobilePhone' label='Mobile Phone' variant={variant} fullWidth required={required}/>
                </Grid>
                {enrollment &&
                    <Grid item xs={3}>
                        <SelectField name='notifyContactForCourseEmail' code='whether' label='Copy course-related emails to the contact person?' variant={variant} fullWidth required={required}
                        helperText='Select Yes to email copies of all course-related correspondence to the contact person'/>
                    </Grid>
                }
            </Grid>
        </Form>
    );
}

function MobileContactPerson(props) {
    const {value={}, change={}, readOnly, required, enrollment = false} = props;

    const variant = readOnly? 'standard':'outlined';

    return (
        <Form value={value} change={change} onChange={props.onChange} fullWidth readOnly={readOnly}>
            <Grid container spacing={2} item xs={12}>
                {/*姓名*/}
                <Grid item xs={12}>
                    <TextField name='contactPerson' label='Name' variant={variant} fullWidth required={required}/>
                </Grid>
                {/*電子郵件*/}
                <Grid item xs={12}>
                    <TextField name='contactEmail' label='Email' variant={variant} fullWidth required={required}/>
                </Grid>
                {/*手機*/}
                <Grid item xs={12}>
                    <TextField name='contactMobilePhone' label='Mobile Phone' variant={variant} fullWidth required={required}/>
                </Grid>
                {enrollment &&
                    <Grid item xs={12}>
                        <SelectField name='notifyContactForCourseEmail' code='whether' label='Copy course-related emails to the contact person?' variant={variant} fullWidth required={required}/>
                    </Grid>
                }
            </Grid>
        </Form>
    );
}

export default ContactPerson;
export {MobileContactPerson};